<div class="population-detail">
  <button mat-button class="population-detail__back" (click)="goBack()" aria-label="Back to populations">
    <mat-icon fontIcon="arrow_back" aria-hidden="true"></mat-icon>
    <span>Back to populations</span>
  </button>

  @if (!loading) {
    @if (notFound) {
      <div class="population-detail__empty">
        <mat-icon fontIcon="help_outline" aria-hidden="true"></mat-icon>
        <h2>Population not found</h2>
        <p>The population you’re looking for doesn’t exist or was removed.</p>
        <button mat-flat-button color="primary" (click)="goBack()">
          <mat-icon fontIcon="arrow_back" aria-hidden="true"></mat-icon>
          Return to list
        </button>
      </div>
    }
    @if (!notFound) {
      <div class="population-detail__content">
        <div class="population-detail__header">
          <div class="population-detail__heading">
            <h1>{{ activePopulationName }}</h1>
            @if (!isNew && population?.description) {
              <p class="population-detail__subtitle">
                {{ population?.description }}
              </p>
            }
          </div>
          <div class="population-detail__header-actions">
            <app-aid-year [disabled]="editMode"></app-aid-year>
          </div>
        </div>
        @if (population && populationCopy) {
          <app-population
            [pop]="editMode ? populationCopy : population"
            [editMode]="editMode"
            [isNew]="isNew"
            (edit)="startEdit()"
            (delete)="confirmDelete()"
            (savePopulation)="save()"
            (cancelEdit)="cancel()"
          ></app-population>
        }
      </div>
    }
  } @else {
    <div class="population-detail__loading">Loading population…</div>
  }

</div>
